export const formatDate = (val: number | string, options?: Intl.DateTimeFormatOptions) => {
	if (!val) return ''

	try {
		let date: Date

		if (typeof val === 'string') {
			date = new Date(val)
		} else {
			date = new Date(val * 1000)
		}

		// Check if the year is different from current year
		const currentYear = new Date().getFullYear()
		const dateYear = date.getFullYear()
		const showYear = dateYear !== currentYear

		const defaults: Intl.DateTimeFormatOptions = {
			// Use browser's timezone by omitting timeZone option
			month: 'short',
			day: 'numeric',
			hour: 'numeric',
			minute: 'numeric',
			hour12: false,
			...options,
		}

		// Only include year if it's different from current year
		if (showYear) {
			defaults.year = 'numeric'
		}

		return date.toLocaleString('en-US', defaults)
	} catch (e) {
		return '-'
	}
}
